import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
	Button,
	TextField
} from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { getTextById, updateText } from '../../../../api/text'
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'
import Editor from '../../../components/editor/Editor'
import { changes, setChanges } from '../../../../utils/globals'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'


function getEmptyText() {
  return {
    title: {},
    content: {}
  }
}

export default function EditTextsPage() {
  const [text, setText] = useState(getEmptyText())
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const textId = useParams().id
  const history = useHistory()

  const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()

  useEffect(() => setChanges(-2), []);
  useEffect(() => {
    setChanges(changes+1)
  }, [text]);

  useEffect(() => {
    if (!textId) {
      disableLoadingData()
      alertError({ error: null, customMessage: 'Could not get text.' })
      setChanges(0);
      return history.push('/texts')
    }
    getTextById(textId).then(res => {
      if (res.status === 200) {
        setText(res.data)
        disableLoadingData()
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get text.' })
      setChanges(0);
      history.push('/texts')
    })
  }, [textId, disableLoadingData, history])

  function saveText() {
    updateText(textId, text).then(res => {
        if (res.status === 200) {
          alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
          setChanges(0);
          history.push('/texts')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not save changes.' })
      })
  }

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === ' ') return
      if (!text[element]) text[element] = {}
      let newText = text[element]
      newText[lang] = event.target.value
      setText({ ...text, [element]: newText })
    } else setText({ ...text, [element]: event.target.value })
  }

  const handleChangeEditor = (element, lang, value) => {
    if (lang) {
      if (value === ' ') return
      if (!text[element]) text[element] = {}
      let newText = text[element]
      newText[lang] = value
      setText({ ...text, [element]: newText })
    } else setText({ ...text, [element]: value })
  }


  const renderMultilanguageTabContent = lang => {
    return (
      <>
        <TextField
          id={`title`}
					label="Title"
          value={(text.title && text.title[lang]) || ''}
          onChange={handleChange('title', lang)}
          InputLabelProps={{
            shrink: true
          }}
          margin="normal"
          variant="standard"
          required
        />
        <Editor
          body={(text.content && text.content[lang]) || ''}
          setBody={new_body => handleChangeEditor('content', lang, new_body)}
          className='max-height'
          lang={lang}
          placeholder={'Enter text content here...'}
          name="Content"
        />
      </>
    )
  }

  if (isLoadingData)
    return <ContentSkeleton />
  else return (
    <>
      <Card>
        <CardHeader title='Edit text'>
          <div className='mt-5'>
            <Button
              onClick={() => {
                if (changes <= 0) history.push('/texts')
                else setOpenConfirmDialog(true);
              }}
              variant="outlined"
              style={{ marginRight: '20px' }}>
              Back
            </Button>
            <Button
              onClick={() => saveText()}
              variant="outlined"
              color="primary"
              style={{ marginRight: '20px' }}>
              Save text
            </Button>
          </div>
        </CardHeader>
        <CardBody>
          <MultilanguageTabBlock
						multilanguageTabContent = {renderMultilanguageTabContent}
					/>
          <br />
        </CardBody>
        <ConfirmDialog
          title={
            "Are you sure you want to go back? You will lose all your changes."
          }
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            setChanges(0);
            history.push('/texts')
          }}
          onDecline={() => {
            setChanges(0);
          }}
        />
      </Card>
    </>
  );
}
